
import { defineComponent } from "vue";

import Loader from "@/components/Loader.vue";
import RGPDLink from "@/components/RGPDLink.vue";
import GcuLink from "@/components/gcuLink.vue";
import { State } from "@/store";
import { mapState } from "vuex";
import RemindsMeCheckbox from "@/components/RemindsMeCheckbox.vue";

export default defineComponent({
    name: "Signup",
    components: {
        Loader,
        GcuLink,
        RGPDLink,
        RemindsMeCheckbox
    },
    data() {
        return {
            email: "",
            password: "",
            passType: `password`,
            isPassHidden: true,
            isPending: false,
            error: "",
            remindsMe: false
        };
    },
    computed: {
        formInvalid() {
            return !this.email.length || !this.password.length;
        },
        ...mapState({
            authenticated: (state: State) => state.auth.authenticated,
            qrcodeObject: (state: State) => state.qrcode.qrcodeObject
        })
    },
    watch: {
        async authenticated() {
            if (this.authenticated) {
                this.isPending = false;

                // if logged with wrong account
                if (
                    !this.qrcodeObject.isOpen &&
                    this.$store.state.auth.userId !== this.qrcodeObject.experiences[0].ownerId
                ) {
                    this.error = this.$t("signInUp.notQrOwner");
                    await this.$store.dispatch("auth/logout");
                } else {
                    this.$router.replace("Upload");
                }
            }
        }
    },
    methods: {
        showPassword() {
          if (this.isPassHidden) {
                this.passType = `text`;
                this.isPassHidden = false;
            } else {
                this.passType = `password`;
                this.isPassHidden = true;
            }
        },
        onEmailInput(ev: Event) {
            const input = ev.target as HTMLInputElement;
            input.value = input.value.toLowerCase();
        },
        async submitForm() {
            this.error = "";
            this.isPending = true;
            try {
                await this.$store.dispatch("auth/login", {
                    email: this.email,
                    password: this.password,
                    remindsMe: this.remindsMe
                });
            } catch (e) {
                this.isPending = false;
                this.error = this.$t("signInUp." + e.message);
            }
        },

        updateRemindsMe(value) {
            this.remindsMe = value;
        },

        async googleSignIn() {
            try {
                const googleUser = await this.$gAuth.signIn();

                if (!googleUser) {
                    throw new Error("User is null");
                }

                const token = googleUser.getAuthResponse().id_token;
                await this.$store.dispatch("auth/googleSignIn", token);
            } catch (e) {
                if (e.error === "popup_closed_by_user") {
                    return;
                }

                if (e?.message?.length) {
                    this.error = this.$t("signInUp." + e.message);
                } else {
                    this.error = this.$t("signInUp.unknownError");
                }
            }
        }
    }
});
